<template>
  <div class="lc-table-column-filter">
    <template v-if="displayType == 'dialog'">
      <div class="lc-table-column-filter__trigger" ref="trigger">
        <slot></slot>
      </div>
      <el-dialog
        :title="title"
        v-model="isDialogShow"
        :modal="true"
        :width="width"
        top="10%"
        append-to-body
        :close-on-click-modal="false"
        custom-class="lc-table-column-filter__dialog"
      >
        <draggable v-if="isDialogShow" v-model="columnList" ghost-class="lc-table-column-filter__ghost">
          <el-checkbox
            v-for="(column, index) in columnList"
            v-model="column[selectedKey]"
            :key="index"
            :title="column[labelKey]"
          >
            <lc-svg-icon icon-class="draggable" />{{ column[labelKey] }}
          </el-checkbox>
        </draggable>
        <div slot="footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </div>
      </el-dialog>
    </template>
    <el-popover
      v-else
      popper-class="lc-table-column-filter__popover"
      :width="width"
      :title="title"
      :content="content"
      :trigger="trigger"
      :placement="placement"
    >
      <slot slot="reference"></slot>
      <draggable v-model="columnList" ghost-class="lc-table-column-filter__ghost" @end="updateInput">
        <el-checkbox
          v-for="(column, index) in columnList"
          v-model="column[selectedKey]"
          :key="index"
          :title="column[labelKey]"
        >
          <lc-svg-icon icon-class="draggable" />{{ column[labelKey] }}
        </el-checkbox>
      </draggable>
    </el-popover>
  </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  components: { draggable },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    selectedKey: {
      type: String,
      default: 'showFlag'
    },
    displayType: {
      type: String,
      default: 'dialog'
    }
  },
  data() {
    return {
      isDialogShow: false,
      title: '自定义展示列',
      content: '',
      trigger: 'click',
      placement: 'bottom',
      columnList: []
    };
  },
  watch: {
    value: {
      handler() {
        this.initColumn();
      },
      immediate: true
    }
  },
  computed: {
    width() {
      if (this.displayType == 'dialog') {
        if (this.value.length < 8) {
          return '535px';
        } else if (this.value.length < 15) {
          return '715px';
        } else {
          return '900px';
        }
      } else {
        return '180';
      }
    }
  },
  created() {},
  methods: {
    initColumn() {
      this.columnList = this.displayType == 'dialog' ? JSON.parse(JSON.stringify(this.value)) : this.value;
    },
    updateInput() {
      this.$emit('input', this.columnList);
    },
    handleSlotClick() {
      this.initColumn();
      this.isDialogShow = true;
    },
    handleSubmit() {
      this.updateInput();
      this.isDialogShow = false;
    },
    handleClose() {
      this.isDialogShow = false;
    }
  },
  mounted() {
    if (this.displayType == 'dialog' && document.addEventListener) {
      this.$refs.trigger.addEventListener('click', this.handleSlotClick, false);
    }
  },
  beforeUnmounted() {
    if (this.displayType == 'dialog' && document.removeEventListener) {
      this.$refs.trigger.removeEventListener('click', this.handleSlotClick, false);
    }
  }
};
</script>
<style lang="scss">
.lc-table-column-filter {
  &__dialog {
    .el-checkbox {
      margin-bottom: 10px;
      cursor: move;
      .el-checkbox__label {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 120px;
        vertical-align: top;
      }
    }
  }
  &__popover {
    max-height: 300px;
    overflow: overlay;
    .el-checkbox {
      display: block;
      margin-bottom: 5px;
      cursor: move;
      .el-checkbox__label {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 120px;
        vertical-align: top;
      }
    }
  }
  &__ghost {
    opacity: 0.5;
    outline: 1px dashed #bbb;
  }
}
</style>
